import { render, staticRenderFns } from "./AssignSpecificPercentages.vue?vue&type=template&id=eb264d0e&scoped=true"
import script from "./AssignSpecificPercentages.vue?vue&type=script&lang=js"
export * from "./AssignSpecificPercentages.vue?vue&type=script&lang=js"
import style0 from "./AssignSpecificPercentages.vue?vue&type=style&index=0&id=eb264d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb264d0e",
  null
  
)

export default component.exports